import ChartTitle from './ChartTitle';
import * as S from './styled/Chart.styled';

const ChartHeader = ({ title, titleTooltip, filter, showDivider = true, subtitle, gutterBottom = false }) => (
	<S.ChartHeaderWrapper gutterBottom={gutterBottom}>
		<S.ChartHeaderStyled>
			<div>
				{title && (
					<ChartTitle tooltip={titleTooltip} subtitle={subtitle}>
						{title}
					</ChartTitle>
				)}
			</div>
			{filter && <S.ChartFilterStyled>{filter}</S.ChartFilterStyled>}
		</S.ChartHeaderStyled>

		{showDivider && <S.Divider />}
	</S.ChartHeaderWrapper>
);

export default ChartHeader;
